/*
Author: Anton Kiiko
Component: Unauthorized Layout
*/
import { ROUTES_PATH_URLS } from 'components/routing/constants/routes';
import { Button } from 'components/shared/Button';
import { Link } from 'components/shared/Link';
import { useRouter } from 'next/router';
import React, { HTMLProps } from 'react';

import { ContactLink, PageContainer, Row, Section, Wrapper } from './UnauthorizedLayout.css';

export const UnauthorizedLayout = ({
  actionButton,
  contactLink,
  errorMessage,
}: IUnauthorizedLayout) => {
  const router = useRouter();

  const signOut = () => {
    router.push(ROUTES_PATH_URLS.account_sign_out);
  };

  return (
    <PageContainer>
      <Wrapper id="unauthorized-wrapper">
        <Section id="unauthorized-section">
          <Row>{errorMessage}</Row>
          {actionButton && (
            <Row $marginTop="1em">
              <Button onClick={actionButton.onClick ? actionButton.onClick : signOut}>
                {actionButton.title}
              </Button>
            </Row>
          )}
          {contactLink && (
            <ContactLink>
              <Link href={contactLink}>Learn more</Link>
            </ContactLink>
          )}
        </Section>
      </Wrapper>
    </PageContainer>
  );
};

export interface IUnauthorizedLayout {
  errorMessage: string;
  actionButton?: HTMLProps<HTMLButtonElement>;
  contactLink?: string;
}
